(function () {
	'use strict';

	angular.module('qbePortal').directive('qbGroupCheckboxMaxLimit', function () {
		return {
			restrict: 'AE',
			scope: {
				numberChecked: '<',
				maxAllowed: '<',
				ngModel: '<',
			},
			link: function (scope, elm, attrs, ctrl) {
				scope.$watch('numberChecked', function () {
					scope.ngModel.$setValidity('qbMaxAllowed', scope.numberChecked <= scope.maxAllowed);
				})
			}
		};
	});
})();
